import { Controller } from "@hotwired/stimulus"
import { curtainShift } from "../lib/geometry"

export default class extends Controller {
  static targets = ["button", "stage", "status"]

  connect() {
    this.arranged = false
    this.buildStrips()
  }

  buildStrips() {
    const count = 12
    const height = 160 / count
    const namespace = "http://www.w3.org/2000/svg"

    for (let index = 0; index < count; index += 1) {
      const top = 90 + index * height
      const clip = document.createElementNS(namespace, "clipPath")
      const clipId = `curtain-strip-${index}`
      clip.id = clipId
      const rect = document.createElementNS(namespace, "rect")
      rect.setAttribute("x", "120")
      rect.setAttribute("y", top)
      rect.setAttribute("width", "420")
      rect.setAttribute("height", height + 0.75)
      clip.append(rect)

      const group = document.createElementNS(namespace, "g")
      group.classList.add("curtain-strip")
      group.dataset.shift = curtainShift(index, count, 80)
      const shape = document.createElementNS(namespace, "polygon")
      shape.setAttribute("points", "140,90 420,90 500,250 220,250")
      shape.setAttribute("fill", index % 2 ? "#38bdf8" : "#7dd3fc")
      shape.setAttribute("stroke", "#0369a1")
      shape.setAttribute("stroke-width", "1")
      shape.setAttribute("clip-path", `url(#${clipId})`)
      group.append(clip, shape)
      this.stageTarget.append(group)
    }
  }

  toggle() {
    this.arranged = !this.arranged
    this.stageTarget.querySelectorAll(".curtain-strip").forEach((strip) => {
      strip.style.transform = this.arranged ? `translateX(${strip.dataset.shift}px)` : "translateX(0)"
    })
    this.buttonTarget.textContent = this.arranged ? "恢复平行四边形" : "拉开窗帘"
    this.statusTarget.textContent = this.arranged ? "细条重新排列成长方形，底和高没有改变。" : "平行四边形已恢复，准备再次观察。"
  }
}
